// Opens an external URL as reliably as possible across every context Liberio runs in:
// a normal browser tab, an installed PWA (standalone display mode), and in-app webviews
// such as Instagram / Facebook / Messenger where `window.open('_blank')` is silently
// blocked and returns null — which is what surfaced the red "Le lien partenaire est
// indisponible pour le moment." error on partner links.
//
// Strategy: try a background tab first (best UX — keeps Liberio open behind the
// partner). If the environment refuses it, fall back to a top-level navigation, which
// always works AND lets the OS hand off to the partner's native app via iOS Universal
// Links / Android App Links — a blocked popup never triggers that hand-off, so this
// fallback is also what makes "open the app if installed, otherwise the website" work.
export function openExternalUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  // Appel et SMS : le système ouvre l'app du téléphone, sans onglet à créer.
  if (url.startsWith('tel:') || url.startsWith('sms:')) {
    window.location.href = url;
    return true;
  }

  let opened: Window | null = null;
  try {
    opened = window.open(url, '_blank', 'noopener,noreferrer');
  } catch {
    opened = null;
  }
  if (opened) {
    return true;
  }

  try {
    window.location.assign(url);
    return true;
  } catch {
    return false;
  }
}
